module.exports = __webpack_public_path__ + "img/Ireland.cdd1c826.svg";